import { render, staticRenderFns } from "./DefinitionSlideover.vue?vue&type=template&id=9d024672"
import script from "./DefinitionSlideover.vue?vue&type=script&lang=js"
export * from "./DefinitionSlideover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports